const WISHLIST_KEY = 'theme_wishlist_ids';

class Wishlist {
  static getIds() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  }
  static hasId(id) {
    return this.getIds().includes(id);
  }
  static toggle(id) {
    let ids = this.getIds();
    if (ids.includes(id)) {
      ids = ids.filter(i => i !== id);
    } else {
      ids.push(id);
    }
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids } }));
  }
}

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('product-id');
    this.btn = this.querySelector('button');
    
    this.updateState = this.updateState.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    this.updateState();
    if (this.btn) this.btn.addEventListener('click', this.toggle);
    document.addEventListener('wishlist:updated', this.updateState);
  }

  disconnectedCallback() {
    if (this.btn) this.btn.removeEventListener('click', this.toggle);
    document.removeEventListener('wishlist:updated', this.updateState);
  }

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    Wishlist.toggle(this.productId);
  }

  updateState() {
    const isActive = Wishlist.hasId(this.productId);
    if (isActive) {
      this.setAttribute('active', '');
    } else {
      this.removeAttribute('active');
    }
  }
}

customElements.define('wishlist-button', WishlistButton);

class WishlistPage extends HTMLElement {
  constructor() {
    super();
    this.resultsContainer = this.querySelector('#wishlist-results');
    this.emptyMessage = this.querySelector('.wishlist-empty-message');
    this.loadingMessage = this.querySelector('.wishlist-loading-message');
  }

  connectedCallback() {
    this.render();
    document.addEventListener('wishlist:updated', () => this.render(false));
  }
  
  async render(showLoading = true) {
    const ids = Wishlist.getIds();
    
    if (ids.length === 0) {
      if (this.resultsContainer) this.resultsContainer.innerHTML = '';
      if (this.emptyMessage) this.emptyMessage.style.display = 'block';
      if (this.loadingMessage) this.loadingMessage.style.display = 'none';
      return;
    }
    
    if (showLoading && this.loadingMessage) {
       this.loadingMessage.style.display = 'block';
       if (this.resultsContainer) this.resultsContainer.innerHTML = '';
    }
    if (this.emptyMessage) this.emptyMessage.style.display = 'none';

    const query = ids.map(id => `id:${id}`).join(' OR ');
    
    try {
      const routesRoot = window.Shopify ? window.Shopify.routes.root : '/';
      const response = await fetch(`${routesRoot}search?type=product&q=${encodeURIComponent(query)}&view=wishlist-items`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const apiResults = doc.querySelector('.wishlist-api-container');
      
      if (this.resultsContainer && apiResults) {
        this.resultsContainer.innerHTML = apiResults.innerHTML;
      } else if (this.resultsContainer) {
        this.resultsContainer.innerHTML = '<p class="wishlist-empty-message">Could not load items.</p>';
      }
      if (this.loadingMessage) this.loadingMessage.style.display = 'none';
    } catch (err) {
      console.error('Failed to load wishlist items', err);
      if (this.loadingMessage) this.loadingMessage.style.display = 'none';
    }
  }
}

customElements.define('wishlist-page', WishlistPage);
